import React, { useContext } from 'react'
import { store, StateProvider } from '../Store';

export default function FooterBottom() {

  const { state, dispatch } = useContext(store);

  const styleTheme = {
    'link': `${state?.configData && state.configData.theme}-link`
  }

  return (
    <div className={ "odisea-page-footer-bottom" }>
      {/*
        <p>Powered by <a className={styleTheme.link} href="https://www.cepal.org/en/topics/redatam" target="_blank">REDATAM</a> | <a href="/odisea/terminos-y-condiciones" className={styleTheme.link} > Términos y condiciones </a> | <a href="/odisea/contacto" className={styleTheme.link} > Contacto</a> | © 1985 - 2022 | CELADE, Population Division of ECLAC - United Nations. All rights reserved. </p>
      */}
      <p className={styleTheme.link}><div dangerouslySetInnerHTML={{__html: state?.configData && state.configData.footerContent}} /></p>
    </div>
  )
}
